import React from 'react';

const KEY_DOWN = 40;
const KEY_UP = 38;
const KEY_ENTER = 13;

class SearchBox extends React.Component {
  componentDidMount() {
    const { inputRef } = this.props;
    inputRef.current.spellcheck = false;
  }

  handleKeyDown = event => {
    const { scrollView, enterKeyBoard } = this.props;
    switch (event.keyCode) {
      case KEY_ENTER:
        enterKeyBoard();
        break;
      case KEY_UP:
        scrollView(-1);
        break;
      case KEY_DOWN:
        scrollView(1);
        break;
      default:
    }
  };

  contextMenu = e => {
    e.preventDefault();
    this.props.inputRef.current.blur();
  };

  focusInput = () => {
    const { inputRef, clickSearchBox } = this.props;
    clickSearchBox();
    inputRef.current.focus();
  };

  getTicker = () => {
    const { textSearch } = this.props;
    return textSearch;
  };

  getCodeName = () => {
    const { currentSearch } = this.props;

    return currentSearch && currentSearch.codeName
      ? currentSearch.codeName
      : '--';
  };

  getExchange = () => {
    const { currentSearch } = this.props;
    if (currentSearch && currentSearch.exchange === '') {
      return '';
    }

    const codeNameAndExchange =
      currentSearch && currentSearch.exchange ? currentSearch.exchange : '--';

    return `/ ${codeNameAndExchange}`;
  };

  onInputChange = e => {
    const { handleChange } = this.props;
    handleChange(e.target.textContent);
  };

  render() {
    const {
      inputRef,
      isShowDropDown,
      isShowNameAndIndex,
      customWidth,
    } = this.props;
    const codeName = this.getCodeName();
    const exchange = this.getExchange();
    return (
      <div onClick={this.focusInput} className="d-flex organization-search-box">
        <div
          style={{ maxWidth: customWidth, overflow: 'hidden' }}
          onInput={this.onInputChange}
          onKeyDown={this.handleKeyDown}
          className="ticker"
          ref={inputRef}
          suppressContentEditableWarning={true}
          contentEditable={true}
        >
          {isShowDropDown ? '' : this.getTicker()}
        </div>

        {isShowDropDown || !isShowNameAndIndex || (
          <div className="small-info-ticker d-flex flex-fill">
            <div
              className={`company-name ${exchange || 'no-exchange'}`}
              title={codeName}
            >
              {codeName}
            </div>
            <div className="exchange">{exchange}</div>
          </div>
        )}
      </div>
    );
  }
}

export default SearchBox;
